import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import axios from "axios";
import {serverLink} from "../../resources/url";
import { projectshortCode} from "../../resources/constants";
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import {setApplicationDetails, setGeneralDetails, setLoginDetails} from "../../actions/actions";
import {Button} from "react-bootstrap";
import Header from "../common/header/header";
import Sidebar from "../common/sidebar/sidebar";
function UndergraduateDocument(props) {
    const navigate = useNavigate();
    const [userData] = useState(props.applicationLogin);
    const addForm = () => {
        setRegister({
            ApplicationID: props.applicationData.EntryID,
            DocumentType: "",
            file: "",
        });
    };
    const [register, setRegister] = useState({
        ApplicationID: props.applicationData.EntryID,
        DocumentType: "",
        file: "",
    });

    const allApplicationData = async () => {
        await axios
            .get(
                `${serverLink}application/ug/application/data/${props.applicationData.EntryID}`
            )
            .then((response) => {
                props.setOnGeneralDetails(response.data);
                // setJambData(response.data.jamb);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const onSubmit = async (sendData) => {
        toast.info(`Submitting... Please wait!`);

        if (register.DocumentType === "") {
            toast.error("please select document type")
            return
        }
        if (register.file === "") {
            toast.error("please select a file")
            return
        }
        const fdt = new FormData();
        fdt.append("ApplicationID", register.ApplicationID);
        fdt.append("DocumentType", register.DocumentType);
        fdt.append("photo", register.file);
        fdt.append("code", projectshortCode);
        axios.post(`${serverLink}application/upload-documents`, fdt)
            .then((res) => {
                if (res.data.message === "success") {
                    allApplicationData();
                    toast.success(`Document Uploaded`);
                    addForm()
                } else if (res.data.message === "already added"){
                    toast.error(`Document Already Added`);
                }
                else {
                    toast.error(`Something went wrong submitting your document!`);
                }
            })
            .catch((error) => {
                console.log("Error", error);
            });
    };

    // const onEdit = (e) => {
    //     const id = e.target.id
    //     const value = id === "file" ? e.target.files[0] : e.target.value
    //
    //     setRegister({
    //         ...register,
    //         [id]: value,
    //     });
    // };

    const [isFileTooLarge, setIsFileTooLarge] = useState(false);

    const onEdit = (e) => {
        const id = e.target.id;
        let value = e.target.value;

        if (id === "file") {
            const file = e.target.files[0];

            if (file) {
                const fileSizeMB = file.size / (1024 * 1024);
                if (fileSizeMB > 1) {
                    toast.error("File size exceeds 1MB. Please select a smaller file.");
                    setIsFileTooLarge(true);
                    return;
                }

                value = file;
                setIsFileTooLarge(false);
            }
        }

        setRegister({
            ...register,
            [id]: value,
        });
    };

    const onPrevious = () => {
        navigate("/undergraduate/guardian-information");
    };

    const onNext = () => {
        navigate("/undergraduate/application-preview");
    };
    const deleteItem = async (id, image) => {
        if (id) {
            toast.info(`Deleting... Please wait!`);
            await axios
                .delete(`${serverLink}application/pg/document/delete/${id}`)
                .then((res) => {
                    if (res.data.message === "success") {
                        allApplicationData();
                        toast.success(`Deleted`);
                    } else {
                        toast.error(
                            `Something went wrong. Please check your connection and try again!`
                        );
                    }
                })
                .catch((error) => {
                    console.log("NETWORK ERROR", error);
                });
        }
    };

    useEffect(() => {
        if (props.applicationLogin.length === 0) {
            navigate("/login");
        }
    }, [props.applicationLogin])

    return (
        // loading ?
        //     <Loader/>
        //     :
        <>
            <div className="main-wrapper">
                <Header/>
                <Sidebar/>
                <div className="page-wrapper">
                    <div className="content">
            <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                    <div className="my-auto mb-2">
                        <h3 className="page-title mb-1">Welcome, {`${userData.FirstName} ${userData.MiddleName} ${userData.Surname}`
                        }</h3>
                        <nav>
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item">
                                    <a href="">Dashboard</a>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">Document Uploads</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <div className="row justify-content-center" style={{marginTop:"-40px"}}>
                <div className="col-md-10 d-flex justify-content-center align-items-center min-vh-50">
                    <div className="flex-fill">
                        <br />
                        <form className="login bg-white shadow p-5 mt-4">
                            <h5>Document Uploads</h5>
                            <div className="mt-3">
                                <h3 className="mb-2 text-danger">Note: Please endeavour to upload the right document, it will determine the decision of your admission.</h3>
                            </div>
                            <div className="col-md-12">
                                <hr />

                                <div className="row">
                                    <div className="col-lg-6 col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="DocumentType" className="form-label">Document Type</label>
                                            <select
                                                id="DocumentType"
                                                name="DocumentType"
                                                className="form-control"
                                                onChange={onEdit}
                                            >
                                                <option value="">Select Option</option>
                                                {props.appRequirement ? (
                                                    <>
                                                        {props.appRequirement.map((item, index) => {
                                                            return (
                                                                <option key={index} value={item.DocumentName}>
                                                                    {item.DocumentName}
                                                                </option>
                                                            );
                                                        })}
                                                    </>
                                                ) : (
                                                    ""
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            {/* <label htmlFor="Designation">File <strong className="text-danger" ><small> &emsp;(File size must not exceed 1mb)</small></strong></label> */}

                                            {/* {
                                                register.DocumentType !== '' ?
                                                    <SimpleFileUpload
                                                        maxFileSize={1}
                                                        apiKey={simpleFileUploadAPIKey}
                                                        tag="alansar-application"
                                                        onSuccess={handleFile}
                                                        preview="false"
                                                        width="100%"
                                                        height="100"
                                                    /> : <div className="pt-5 ">Select Document Type to Upload</div>
                                            } */}

                                            {
                                                register.DocumentType !== '' ?
                                                    <>
                                                        <label htmlFor="file" className="form-label">File <strong className="text-danger" ><small> &emsp;(File size must not exceed 1mb)</small></strong></label>
                                                        <input
                                                            type="file"
                                                            accept=".pdf, .jpg, .png, .jpeg"
                                                            id="file"
                                                            name="file"
                                                            className="form-control"
                                                            placeholder="File Name"
                                                            required
                                                            onChange={onEdit}
                                                        />
                                                        <span className="badge bg-secondary text-white">
                                                            Only .pdf, .jpg, .png, .jpeg are allowed
                                                        </span></>
                                                    : <div className="pt-4 ">Select Document Type to Upload</div>
                                            }


                                        </div>
                                    </div>
                                    <div className="col-md-12 mt-3">
                                        <button className="btn btn-md btn-info w-25" disabled={isFileTooLarge} onClick={onSubmit} type="button">
                                            Add
                                        </button>
                                    </div>
                                </div>
                                <br />
                                <h4>Required Documents</h4>
                                <br/>
                                <ol style={{ listStyleType: "decimal" }}>
                                    {props.appRequirement && props.appRequirement
                                        .filter(item => item.IsRequired === 1)
                                        .map((item, index) => (
                                            <li key={index}>{item.DocumentName}</li>
                                        ))
                                    }
                                </ol>

                                <div className="table-responsive">
                                    {props.applicant_data.documents?.length > 0 ? (
                                        <table className="table table-hover">
                                            <thead>
                                            <tr>
                                                <th>Document Type</th>
                                                <th>File</th>
                                                <th>Action</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {props.applicant_data.documents.map((item, index) => (

                                                <tr key={index}>
                                                    <td>{item.DocumentType}</td>
                                                    <td>
                                                        <a
                                                            target="_blank"
                                                            referrerPolicy="no-referrer"
                                                            href={item.FileName !== null ?`${serverLink}public/uploads/${projectshortCode}/application/document/${item.FileName}` : ""}
                                                        >
                                                            <i className="fa fa-file" />
                                                        </a>
                                                    </td>
                                                    <td>
                                                        <Button
                                                            variant="danger"
                                                            onClick={() =>
                                                                deleteItem(item.EntryID, item.FileName)
                                                            }
                                                        >
                                                            <i
                                                                className="fa fa-trash"
                                                                style={{ fontsize: "30px" }}
                                                            />
                                                        </Button>
                                                    </td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                    ) : (
                                        <div className="alert alert-info">
                                            There is no record. Click on Add Document
                                        </div>
                                    )}
                                </div>

                                <div className="col-md-12 mt-3">
                                    <div className="filters-group mb-lg-4 text-center">
                                        <button className="btn btn-dark mx-3 active" onClick={onPrevious}> Previous</button>
                                        <button className="btn btn-dark w-50 active" onClick={onNext}>  Save and Continue</button>
                                    </div>
                                </div>
                                <div>
                                </div>
                            </div></form>                    </div>
                </div>
            </div>
                    </div>
                </div>
            </div>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        applicationLogin: state.loginDetails,
        applicationData: state.applicationDetails,
        appRequirement: state.ApplicationRequirementDetails,
        applicant_data: state.generalDetails,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setOnLoginDetails: (p) => {
            dispatch(setLoginDetails(p));
        },
        setOnGeneralDetails: (p) => {
            dispatch(setGeneralDetails(p));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UndergraduateDocument);
